export default __webpack_public_path__ + "static/media/googlecloudplatform.7951006e.jpg";